/**
 * predictive-search-sku.js
 * ------------------------
 * Extends the theme's <predictive-search> custom element so the site search
 * also matches against variant SKUs, not just product title / vendor / type
 * / variant title.
 *
 * Implementation: monkey-patches PredictiveSearch.prototype.getSearchResults
 * to append `resources[options][fields]=...` including `variants.sku`. The
 * server-rendered HTML is moved into the results container using the DOM
 * Node API (no innerHTML).
 */
(function () {
  function moveChildren(fromEl, toEl) {
    while (toEl.firstChild) toEl.removeChild(toEl.firstChild);
    if (!fromEl) return;
    var nodes = Array.prototype.slice.call(fromEl.childNodes);
    for (var i = 0; i < nodes.length; i++) toEl.appendChild(nodes[i]);
  }

  function applyPatch() {
    var ctor = customElements.get('predictive-search');
    if (!ctor || !ctor.prototype) return false;
    if (ctor.prototype.__skuPatched) return true;

    var FIELDS = 'title,product_type,variants.title,vendor,variants.sku';

    ctor.prototype.getSearchResults = function (query) {
      var self = this;
      var params = new URLSearchParams();
      params.set('q', query);
      params.set('resources[type]', 'product');
      params.set('resources[limit]', '4');
      params.set('resources[options][fields]', FIELDS);
      params.set('section_id', 'predictive-search');

      var url = (window.routes && routes.predictive_search_url
        ? routes.predictive_search_url
        : '/search/suggest') + '?' + params.toString();

      return fetch(url)
        .then(function (response) {
          if (response.ok) return response.text();
          throw new Error(response.status);
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var section = doc.querySelector('#shopify-section-predictive-search');
          if (!section) {
            self.close();
            return;
          }

          moveChildren(section, self.predictiveSearchResults);

          var resultsList = self.predictiveSearchResults.querySelector('#predictive-search-results-list');
          if (!resultsList) {
            var noResults = document.createElement('p');
            noResults.classList.add('predictive-search-no-results');
            noResults.textContent = 'No Results';
            var resultsWrap = self.predictiveSearchResults.querySelector('#predictive-search-results');
            var viewAllBtn = resultsWrap && resultsWrap.querySelector('.predictive-search-btn');
            if (resultsWrap && viewAllBtn) {
              resultsWrap.insertBefore(noResults, viewAllBtn);
            } else if (resultsWrap) {
              resultsWrap.appendChild(noResults);
            }
          }
          self.open();
        })
        .catch(function (err) {
          self.close();
          throw err;
        });
    };

    ctor.prototype.__skuPatched = true;
    return true;
  }

  if (applyPatch()) return;

  if (customElements.whenDefined) {
    customElements.whenDefined('predictive-search').then(function () {
      applyPatch();
    });
    return;
  }

  document.addEventListener('DOMContentLoaded', applyPatch);
})();
